import { Component, OnInit } from '@angular/core';
import { TemplateUpdateService } from '../../../services/template-update.service';
@Component({
  selector: 'accordion-accessibility',
  templateUrl: './accordion-accessibility.component.html',
  styleUrls: ['./accordion-accessibility.component.sass']
})
export class AccordionAccessibilityComponent implements OnInit {
  infoText = this.templateService.accessibilityInfoText;
  header = this.templateService.accessibilityHeader;
  constructor(private templateService: TemplateUpdateService) { }

  ngOnInit(): void {
  }

}
